/**
 * 将用户强制退出到登录页并保留当前的页面path
 * @param {* 当前的页面path} currentPath 
 */
export const kickOut = (currentPath)=>{
    sessionStorage.setItem('loginPath',currentPath)
    window.location.href = `${process.env.PUBLIC_URL}/login`
}